import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "k-game-over__content" }
const _hoisted_2 = { style: {"margin-bottom":"375px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "dot-flashing" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

import { onMounted, ref } from 'vue';
import { useMotion, useMotions } from '@vueuse/motion'
import { useModule } from 'src/modules/modules';
import GameContentArea from './game-content-area.vue';
import Spinner from 'src/components/spinner.vue';
import { delay } from 'src/util/util';


export default /*#__PURE__*/_defineComponent({
  __name: 'game-over',
  emits: ['next', 'leave'],
  setup(__props, { emit }) {

const { game } = useModule();


const title = ref<HTMLElement>()
const titleMotion = useMotion(title, {
    initial: {
        y: 0,
        filter: 'blur(100px)',
        opacity: 0,
        //scale: 3
    },
    enter: {
        filter: 'blur(0px)',
        opacity: 1,
        //scale: 1,
        transition: {
            duration: 800,
            ease: 'easeOut'
        }
    },
    leave: {
        filter: 'blur(100px)',
        opacity: 0,
        y: -300,
        transition: {
            duration: 1000,
            ease: 'easeIn'
        },
    }
})

const spinner = ref();
const spinnerMotion = useMotion(spinner, {
    initial: {
        opacity: 0
    },
    _enter: {
        opacity: 1,
        transition: {
            duration: 250,
            ease: 'easeOut'
        }
    },
    leave: {
        opacity: 0,
        transition: {
            duration: 250,
            ease: 'easeIn'
        },
    }
})

const container = ref();
const containerMotions = useMotion(container, {
    initial: {
        opacity: 1,
        backdropFilter: 'blur(0px)',
        '-webkit-backdrop-filter': 'blur(0px)'
    },
    enter: {
        backdropFilter: 'blur(100px)',
        '-webkit-backdrop-filter': 'blur(100px)',
        transition: {
            duration: 500,
            ease: 'easeOut'
        }
    },
    leave: {
        //opacity: 0,
        backdropFilter: 'blur(0px)',
        '-webkit-backdrop-filter': 'blur(0px)',
        transition: {
            duration: 1000,
            ease: 'easeIn'
        },
    }
})

//containerMotions.apply();

// const GameOverMessages = [
//     'Hm, note quite!',
//     'Almost had it!',
//     'You\'ll get it next time!',
//     'Afraid not!',
//     'So close!',
//     'Not exactly!',
//     'Oof!',
//     'Next Time!',
//     'Dang, sorry!',
//     'Missed it by a whisker!',
//     'So close, yet so far!',
//     'Close, but no cigar!',
//     'Ya goofed.'
// ]

const GameOverMessages = [
    'Ya goofed.',
    // 'My friend, you have goofed it.',
    // 'Goofed it.',
    // 'Colossal goof.',
    // 'Good sir, I do believe you have goofed.',
    // 'You\'ve really done it this time! Goofed it, I mean.',
    // 'Unprecedented goof.',
    // 'You got the goof in you kid.',
    // 'Goofing into the sunrise.',
    // 'If you\'re looking for goofs they\'re in aisle you.',
    // 'The goofs are strong in this one.'
]

//const message = ref<string>(Phaser.Utils.Array.GetRandom(GameOverMessages));
const message = game.matchState.timedOut ? 'Ran out of time.' : 'Not Quite.'

let postGamePromise = game.preparePostGame();
onMounted(() => {
    game.gameScene?.cameras.main.flash(3000, 136, 8 , 8, false, async (camera: unknown, progress: number) => {
        if (progress === 1){
            /**
             * If our main transition is finished (camera flash) and the async work for post-game ad and stats hasn't
             * completed yet, throw up our loader and hold this screen until the work is complete.
             */
            if (!game.postGameReady){
                spinnerMotion.apply('_enter');
                await postGamePromise;
            }

            //await delay(100000); // for testing

            emit('next');
            await Promise.all([
                titleMotion.apply('leave'),
                spinnerMotion.apply('leave'),
                containerMotions.apply('leave')
            ])
            emit('leave');
        }
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GameContentArea, {
    ref_key: "container",
    ref: container,
    "hide-tray": true,
    class: "k-game-over absolute-full-cover",
    "no-pointer-fx": ""
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            ref_key: "title",
            ref: title,
            class: "k-gameover-title"
          }, _toDisplayString(_unref(message)), 513)
        ]),
        _createElementVNode("div", {
          ref_key: "spinner",
          ref: spinner
        }, _hoisted_4, 512)
      ])
    ]),
    _: 1
  }, 512))
}
}

})